export const authorProfile = {
  name: 'Akoka Academic Press',
  role: 'Publisher',
  verified: true,
  titles: 4,
  readers: 1284,
}

export const authorTitles = [
  {
    id: 'at-1',
    title: 'Control Systems Engineering for African Curricula',
    edition: '3rd edition, 2026',
    kind: 'Textbook',
    models: 'Rental ₦2,500 / 30 days · Purchase ₦11,500',
    rentals: 214,
    purchases: 61,
    activeEntitlements: 178,
    earningsNaira: 1_236_500,
    status: 'Published',
  },
  {
    id: 'at-2',
    title: 'Operations Research II — past questions 2018–2025',
    edition: '2025 compilation',
    kind: 'Past questions',
    models: 'Free — institution licence',
    rentals: 0,
    purchases: 0,
    activeEntitlements: 642,
    earningsNaira: 0,
    status: 'Published',
  },
  {
    id: 'at-3',
    title: 'Grid integration of distributed solar in West Africa',
    edition: 'Journal issue 12(3)',
    kind: 'Research paper',
    models: 'Purchase ₦3,500',
    rentals: 0,
    purchases: 38,
    activeEntitlements: 38,
    earningsNaira: 126_350,
    status: 'Published',
  },
  {
    id: 'at-4',
    title: 'Fluid Mechanics — worked examples',
    edition: 'Draft, 2026',
    kind: 'Course pack',
    models: 'Not priced yet',
    rentals: 0,
    purchases: 0,
    activeEntitlements: 0,
    earningsNaira: 0,
    status: 'In review',
  },
]

export const authorEntitlementSummary = [
  { label: 'Active rentals', value: 178, note: 'Access period still running' },
  { label: 'Expired rentals', value: 96, note: 'Transaction retained, access ended' },
  { label: 'Permanent purchases', value: 99, note: 'Licence term unlimited' },
  { label: 'Institution licences', value: 642, note: 'Free within University of Lagos' },
]

export const authorEarnings = {
  grossNaira: 1_362_850,
  platformFeeNaira: 136_285,
  netNaira: 1_226_565,
  pendingPayoutNaira: 214_000,
}
